import React, {useState, useEffect} from 'react'
import Image from '../Image/Image'
import Icons from '../../../components/Icons'
import styled from 'styled-components'
import {fetchEquipment} from '../../../utils/equipment'

const StyledContainer = styled.div`
  min-height: 100%;
  width: 100%;
  display: grid;
  grid-template-rows: auto 1fr 1fr auto;
  grid-template-columns: 320px;
  grid-template-areas: 'image' 'name' 'description' 'location';
  box-sizing: border-box;

  @media (max-width: 1024px) {
    grid-template-columns: 255px;
  }

  @media (max-width: 768px) {
    height: 150px;
    grid-template-rows: 75px 75px;
    grid-template-columns: 150px 275px 1fr;
    grid-template-areas: 'image name location' 'image description location';
  }

  @media (max-width: 420px) {
    height: 192px;
    width: 100%;
    grid-template-rows: 58px 67px 67px;
    grid-template-columns: 58px auto;
    grid-template-areas: 'image name' 'description description' 'location location';
  }
`

const StyledImageContainer = styled.div`
  width: 320px;
  height: 320px;
  grid-area: image;

  @media (max-width: 1024px) {
    width: 255px;
    height: 255px;
  }

  @media (max-width: 768px) {
    width: 150px;
    height: 150px;
  }

  @media (max-width: 420px) {
    width: 58px;
    height: 58px;
    box-sizing: border-box;
    margin-top: 0;
  }
`

const StyledDescription = styled.div`
  font-size: 14px;
  font-weight: normal;
  letter-spacing: -0.3px;
`

const StyledName = styled.div`
  font-size: 22px;
  font-weight: bold;
  color: #000000;
  letter-spacing: -0.3px;

  @media (max-width: 1024px) {
    font-size: 18px;
  }
`

const StyledNameContainer = styled.div`
  grid-area: name;
  color: #a5aab8;
  padding: 19px 24px 19px 24px;
  box-sizing: border-box;
  border-bottom: 1px solid #f3f5fb;

  @media (max-width: 768px) {
    margin: 19px 0 0 0;
    padding: 0 0 0 24px;
    border-bottom: 0;
    border-right: 1px solid #f3f5fb;
  }

  @media (max-width: 420px) {
    font-size: 16px;
    margin: 0;
    padding: 9px 50px 9px 14px;
    border-bottom: 1px solid #f3f5fb;
    border-right: 0;
  }
`

const StyledDescriptionContainer = styled.div`
  grid-area: description;
  padding: 19px 24px 19px 24px;
  border-bottom: 1px solid #f3f5fb;
  box-sizing: border-box;

  @media (max-width: 768px) {
    margin: 0 0 19px 0;
    padding: 8px 0 0 24px;
    border-bottom: 0;
    border-right: 1px solid #f3f5fb;
  }

  @media (max-width: 420px) {
    font-size: 12px;
    margin: 0;
    padding: 9px 15px 9px 15px;
    border-bottom: 1px solid #f3f5fb;
    border-right: 0;
  }
`

const StyledLocationContainer = styled.div`
  grid-area: location;
  padding: 19px 24px 19px 24px;
  box-sizing: border-box;

  @media (max-width: 420px) {
    font-size: 12px;
    margin: 0;
    padding: 12px 15px 9px 15px;
    border-bottom: 0;
  }
`

const StyledDetailContainer = styled.div`
  display: flex;
  align-items: center;
`

const LocationIcon = styled(StyledDetailContainer)`
  width: 30px;
`

const StyledLocation = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: #3395fe;
  letter-spacing: -0.3px;
`

const StyledDepartment = styled.div`
  font-size: 14px;
  color: #a5aab8;
  letter-spacing: -0.3px;
`
const initialState = {
  eqId: '',
  manufacturer: '',
  modelNo: '',
  stdDescription: '',
  use: '',
  blName: '',
  rmId: '',
  rmDescription: ''
}

const Equipment = ({eqId}) => {
  const [equipment, setEquipment] = useState(initialState)

  const {
    mfr,
    modelno,
    stdDescription,
    use1,
    name,
    rmId,
    description,
    imageUrl
  } = equipment

  useEffect(
    () => {
      fetchEquipment({eqId}).then(equipment => {
        setEquipment(equipment)
      })
    },
    [eqId]
  )

  return (
    <StyledContainer>
      <StyledImageContainer>
        <Image url={imageUrl} imageType="equipment" placeholder={false} />
      </StyledImageContainer>

      <StyledNameContainer>
        <StyledName>{eqId}</StyledName>
        <StyledDescription>{stdDescription}</StyledDescription>
      </StyledNameContainer>

      <StyledDescriptionContainer>
        <StyledDescription>{mfr}</StyledDescription>
        <StyledDescription>{modelno}</StyledDescription>
        <StyledDescription>{use1}</StyledDescription>
      </StyledDescriptionContainer>

      <StyledLocationContainer>
        <StyledDetailContainer>
          <LocationIcon>
            <Icons icon="LOCATION" />
          </LocationIcon>
          <div>
            <StyledLocation>
              {name} - {rmId}
            </StyledLocation>
            <StyledDepartment>{description}</StyledDepartment>
          </div>
        </StyledDetailContainer>
      </StyledLocationContainer>
    </StyledContainer>
  )
}

export default Equipment
